import React, { useState } from 'react'
import style from './style.module.scss'
// import { Button, Col, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useRouter } from 'next/router'

function DeleteAccount() {
  const router = useRouter()
  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    watch,
    formState: { errors }
  } = useForm({ mode: 'onTouched' })
  const [isConfirmed, setIsConfirmed] = useState(false)

  function onSubmit() {
    router.push('/')
    console.log({ message: 'Your account has been scheduled for deletion. If you do not want this action to happen, please contact us at hi@cricketbazaar.com within 24 hours.', toastType: 'success' })
  }
  const isValid = !watch('sName') || !watch('sPhone') || !watch('sMessage') || !isConfirmed

  function handleCheckbox(e) {
    setIsConfirmed(e.target.checked)
    if (e.target.checked) {
      clearErrors('confirmDelete')
    } else {
      setError('confirmDelete', { type: 'manual', message: 'Please confirm' })
    }
  }
  return (
       <div className={style.acc}>
        <div className='d-flex flex-column gap-2'>
              <h1>Delete Account</h1>
              <p className='fs-6'>The Delete Account page allows users to permanently delete their account from the system. Upon deletion, all associated data will be removed, and the action cannot be undone. A confirmation process ensures that users are fully aware of the consequences before proceeding.</p>
        </div>
                  <input
                      type='input'
                      placeholder={'Full Name'}
                      {...register('sName', { required: true })}
                      className={
                          'w-full my-2 py-2 px-3 text-sm font-normal text-t-origin placeholder:text-[#808080] bg-card-400 border border-c shadow-none rounded-3'
                      }
                  />
                  {errors?.sName && <span className='text-red-500 mx-2 text-sm'>This Field Is Required</span>}
                  <input
                      type='tel'
                      placeholder={'Phone Number'}
                      {...register('sPhone', {
                        required: 'Phone number is required',
                        maxLength: {
                          value: 10,
                          message: 'Phone number must be 10 digits'
                        },
                        minLength: {
                          value: 10,
                          message: 'Phone number must be 10 digits'
                        },
                        pattern: {
                          value: /^[0-9]*$/,
                          message: 'Phone number must only contain numbers'
                        }
                      })}
                      className={
                          'w-full my-2 py-2 px-3 text-sm font-normal text-t-origin placeholder:text-[#808080] bg-card-400 border border-c shadow-none rounded-3'
                      }
                  />
                  {errors?.sPhone && <span className='text-red-500 mx-2 text-sm'>{(errors?.sPhone).message}</span>}
                  <textarea
                      placeholder={'Reason for Leaving'}
                      {...register('sMessage', { required: true })}
                      className={
                          'w-full my-2 py-2 px-3 text-sm font-normal text-t-origin placeholder:text-[#808080] bg-card-400 border border-c shadow-none rounded-3'
                      }
                  />
                  {errors?.sMessage && <span className='text-red-500 mx-2 text-sm'>This Field Is Required</span>}
                  <div className='my-2 flex items-center mx-2 mt-4'>
                      <input
                          type='checkbox'
                          {...register('confirmDelete', { required: true })}
                          id='confirmDelete'
                          checked={isConfirmed}
                          className='h-4 w-4 mx-2'
                          onChange={(e) => handleCheckbox(e)}
                      />
                      <label htmlFor='confirmDelete' className='text-sm'>
                          I understand that my account will be permanently deleted and cannot be recovered.
                      </label>
                  </div>
                  {errors?.confirmDelete && <span className='text-red-500 mx-2 text-sm'> Please confirm </span>}
          <button className="theme-btn btn btn-primary mt-3 w-100" disabled={isValid}
              onClick={handleSubmit(onSubmit)}>
              <span className={style.btnText}>Delete Account</span>
          </button>
       </div>
  )
}
export default DeleteAccount
